export default "27.2.079\n"